import { useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import type { SiteNavItem } from "../config/siteNav";

type Props = {
  item: SiteNavItem;
};

export function NavDropdown({ item }: Props) {
  const [open, setOpen] = useState(false);
  const leaveTimer = useRef<number | null>(null);
  const children = item.children ?? [];
  const hasMenu = children.length > 0;

  const show = () => {
    if (leaveTimer.current) {
      window.clearTimeout(leaveTimer.current);
      leaveTimer.current = null;
    }
    setOpen(true);
  };

  const hideSoon = () => {
    leaveTimer.current = window.setTimeout(() => setOpen(false), 120);
  };

  if (!hasMenu) {
    return (
      <NavLink
        to={item.href}
        className={({ isActive }) =>
          `nav-tab-link nav-tab-link--solo${isActive ? " nav-tab-link--active" : ""}`
        }
      >
        {item.label}
      </NavLink>
    );
  }

  return (
    <div
      className="nav-tab"
      onMouseEnter={show}
      onMouseLeave={hideSoon}
      onFocus={show}
      onBlur={hideSoon}
    >
      <NavLink
        to={item.href}
        className={({ isActive }) =>
          `nav-tab-link${isActive ? " nav-tab-link--active" : ""}`
        }
      >
        {item.label}
        <span className="nav-chevron" aria-hidden>
          ▾
        </span>
      </NavLink>
      <div className={`nav-dropdown${open ? " nav-dropdown--open" : ""}`}>
        {item.tagline && <p className="nav-dropdown-tagline">{item.tagline}</p>}
        <ul>
          {children.map((child) => (
            <li key={child.href}>
              <NavLink
                to={child.href}
                className="nav-dropdown-link"
                onClick={() => setOpen(false)}
              >
                {child.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
